import { Dashboard } from '@/services/fintalk/services/fintalk-backoffice/dashboards/list'
import { createDialogStore } from '@/stores/use-dialog'

interface DashboardEditDialogData {
  dashboard?: Dashboard
}

export const useDashboardEditDialog =
  createDialogStore<DashboardEditDialogData>()
